import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FacturacionComponent } from './facturacion.component';
import { FacturacionGuard } from './facturacion.guard';

const routes: Routes = [
  {
    path: '',
    title: 'Facturación',
    component: FacturacionComponent,
    canActivate: [FacturacionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FacturacionRoutingModule {}
